import {
    applyMiddleware,
    createStore
} from 'redux';
import createSagaMiddleware from 'redux-saga';

import { constructTealiumMiddleware, coreTags } from '../../core/js/middleware/analytics';
import { categoryTags } from './middleware/analytics';

import ravenMiddleware from '../../core/js/middleware/raven';

import {
    storeLogger
} from '../../core/js/middleware/logger';

import categoryApp from './init/categoryApp';
import categoryInitialState from './init/categoryInitialState';
import { initialState as coreInitialState } from '../../core/js/store';

export function determinePageType(state, isBrandIndexPage = false) {
    const isSearch = _.get(state, 'category.isSearch', false);
    const typeCode = _.get(state, 'category.templateOptions.typeCode', '');
    const hasRecords = _.get(state, 'category.products.totalRecordCount', 0) > 0;
    const isLandingPage = !_.isNull(_.get(state, 'category.landingPage', null));
    const isGateway = (typeCode === "GATEWAY" || typeCode === "GATEWAY_NN");

    if (isGateway) {
        return 'gateway';
    }

    if (isLandingPage || isBrandIndexPage === true) {
        return 'content';
    }

    if (!hasRecords) {
        return '404';
    }

    if (isSearch) {
        return 'search';
    }

    return 'category';
}

export const initialState = Object.assign({}, coreInitialState, categoryInitialState, {
    core: Object.assign({}, coreInitialState.core, {
        pageType: determinePageType(categoryInitialState, window.isBrandIndexPage)
    })
});

export function configureStore() {
    const tealiumMiddleware = constructTealiumMiddleware([coreTags(), categoryTags()]);
    const sagaMiddleware = createSagaMiddleware();
    const createStoreWithMiddleware = createStore(
        categoryApp,
        initialState,
        applyMiddleware(storeLogger('Category'), ravenMiddleware, tealiumMiddleware, sagaMiddleware)
    );
    return Object.assign({}, createStoreWithMiddleware, { runSaga: sagaMiddleware.run });
}
